<template>
  <span v-show="isShowPage">
    <v-row align="center" justify="center">
      <v-col cols="3">
        <v-text-field
          append-icon="mdi-magnify"
          outlined
          solo
          hide-details
          v-model="search"
          class="search"
          placeholder="Search..."
          v-on:keyup.enter="getDataTable()"
          color="#2671D9"
        >
        </v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <v-btn
          class="ma-2"
          depressed
          color="#2671D9"
          dark
          @click="openDialog('add')"
        >
          <v-icon left color="#fff">
            mdi-plus
          </v-icon>
          Tambah
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="itemsPerPage"
          class="datatable"
          :search="search"
          hide-default-footer
          :page.sync="page"
          @page-count="pageCount = $event"
        >
          <template v-slot:[`item.action`]="{ item }">
            <v-btn fab x-small color="primary">
              <v-icon color="#fff" @click="clickDetail(item)">mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-row>
          <v-col class="mt-5" cols="6">
            Menampilkan
            <v-select
              v-model="itemsPerPage"
              :items="[5, 10, 20, 30, 50]"
              dense
              solo
              flat
              class="ml-1 mr-1 size-select"
              @change="itemsPerPage = parseInt($event, 10); page = 1;"
            ></v-select>
            data dari <b>{{ items.length }}</b>
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="text-right mt-5" cols="6">
            <v-pagination v-model="page" :length="pageCount" :total-visible="5"></v-pagination>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <v-row>
            <v-col>
              <span>{{ dialogTitle }}</span>
            </v-col>
            <v-col class="text-right">
              <v-btn
                icon
                x-small
                @click="dialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
            <span v-if="dialogType === 'filter'">
              <!-- for filter if needed -->
            </span>
            <span v-else-if="dialogType === 'add'">
              <ValidationObserver ref="observer">
                <v-row>
                  <v-col class="pb-0 pt-1">
                    <ValidationProvider v-slot="{ errors }" name="Nama Role" rules="required">
                      <div class="label-custom mb-2" :style="'color:' + colorActive">Nama Role</div>
                      <v-text-field
                        v-model="input.name"
                        label="Nama Role"
                        dense
                        solo
                        flat
                        outlined
                        :error-messages="errors"
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pb-0 pt-1">
                    <ValidationProvider v-slot="{ errors }" name="Keterangan" rules="required">
                      <div class="label-custom mb-2" :style="'color:' + colorActive">Keterangan</div>
                      <v-text-field
                        v-model="input.description"
                        label="Keterangan"
                        dense
                        solo
                        flat
                        outlined
                        :error-messages="errors"
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </ValidationObserver>
            </span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            depressed
            color="#999999"
            text
            @click="closeDialog()"
          >
            {{ dialogType === 'filter' ? 'Kembali' : 'Tutup' }}
          </v-btn>
          <v-btn
            v-if="dialogType === 'filter'"
            small
            depressed
            :color="colorActive"
            @click="closeDialog(); getDataTable()"
            dark
          >
            Cari
          </v-btn>
          <v-btn
            v-if="dialogType === 'add'"
            small
            depressed
            :color="colorActive"
            @click="clickSave"
            dark
          >
            Tambah
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
// import Table from '../../components/Table.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import alert from '@/commons/helper/alert.helper'
import RoleService from '@/services/default/RoleService'

const roleService = RoleService.build()
export default {
  name: 'user-management-role',
  components: {
    // Table,
    ValidationProvider,
    ValidationObserver
  },
  data: () => ({
    colorActive: '#2671D9',
    colorInactive: '#9A9A9A',
    headers: [
      // { value: 'number', text: 'No.', sortable: false, align: 'center' },
      { value: 'text', text: 'Role', align: 'left', width: '90%' },
      { value: 'action', text: 'Aksi', align: 'center' }
    ],
    items: [],
    search: '',
    isShowPage: true,
    isFetching: false,
    timer: '',
    // dialog
    dialog: false,
    dialogTitle: '',
    dialogType: '',
    filterOptions: {},
    filter: {},
    input: {
      name: '',
      description: ''
    },
    // client side pagination properties
    page: 1,
    pageCount: 0,
    itemsPerPage: 10
  }),
  async created () {
    // delete localStorage
    // localStorage.removeItem('tableQuery')
    this.getDataTable()
  },
  computed: {},
  mounted: function () {
    // this.$nextTick(() => {
    //   // re-get data every 1 minute
    //   this.timer = setInterval(() => {
    //     const tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
    //     if (tableQuery) {
    //       this.getDataTable(tableQuery.page, tableQuery.size)
    //     } else {
    //       this.getDataTable()
    //     }
    //   }, 60000)
    // })
  },
  destroyed: function () {
    // kill re-get data every 1 minute
    clearInterval(this.timer)
  },
  watch: {
    search: function (val) {
      if (val === '') {
        this.getDataTable()
      }
    }
  },
  methods: {
    openDialog (type) {
      this.dialogType = type
      if (type === 'add') {
        this.dialogTitle = 'Tambah Role'
      } else {
        this.dialogTitle = 'Filter Data'
      }
      this.dialog = true
    },
    closeDialog (type) {
      if (type === 'add') {
        this.input = {
          name: '',
          description: ''
        }
        this.$refs.observer.reset()
      }

      this.dialog = false
    },
    clickDetail (data) {
      console.log(data)
      // this.$router.push({
      //   name: 'user-management-role-detail',
      //   query: {
      //     roleId: '1',
      //     roleName: 'A'
      //   }
      // })
    },
    clickSave () {
      const self = this
      this.$refs.observer.validate().then(success => {
        if (success) {
          const param = Object.assign({
            name: this.input.name,
            descr: this.input.description
          })
          alert.confirmation(async function () {
            const response = await roleService.addData(param)
            if (response.data.success === true) {
              alert.success('Data role berhasil ditambahkan')
              self.resetData()
              self.getDataTable()
            } else {
              alert.failed(response.data.status + ' - ' + response.data.message)
            }
            self.closeDialog()
          }, 'Anda yakin ingin menyimpan data role ini?')
        }
      })
    },
    async getDataTable () {
      this.isFetching = true

      const response = await roleService.getRoleList()
      if (response.data.success === true) {
        const { data: { data } } = response
        this.items = data
      } else {
        alert.failed(response.data.status + ' - ' + response.data.message)
      }
      this.isFetching = false
    }
  }
}
</script>
<style scoped>
  .search {
    height: 48px;
  }
</style>
